module.exports = __webpack_public_path__ + "img/sb05.f90da385.png";